import { useDispatch, useSelector, connect } from "react-redux";

import {
    terceroActions,
    tipoventasActions,
    talonarioActions,
    tipocomprobantesActions,
    comprobanteActions,
    pagoActions,
    usuariosActions,
    departamentoActions,
    municipioActions,
    actividadEconomicaActions,
} from "./store";

import { useEffectAsync } from "./helper/reactHelper";
import { useEffect, useState } from "react";

const CachingController = () => {
    const authenticated = useSelector((state) => !!state.session.user);
    const dispatch = useDispatch();

    let requestCount = 10;
    const [requestSolved, setRequestSolved] = useState(0);

    useEffect(() => {
        setRequestSolved(0);
        return () => {
            setRequestSolved(0);
        };
    }, []);

    useEffect(() => {
        if (!authenticated) setRequestSolved(0);
    }, [authenticated]);

    useEffectAsync(async () => {
        if (authenticated) {
            const response = await fetch("/api/user/getAll");
            if (response.ok) {
                setRequestSolved((prev) => prev + 1);
                dispatch(usuariosActions.refresh(await response.json()));
            } else {
                throw Error(await response.text());
            }
        }
    }, [authenticated]);

    useEffectAsync(async () => {
        if (authenticated) {
            const response = await fetch("/api/tercero?all=true");
            if (response.ok) {
                setRequestSolved((prev) => prev + 1);
                dispatch(terceroActions.refresh(await response.json()));
            } else {
                throw Error(await response.text());
            }
        }
    }, [authenticated]);

    useEffectAsync(async () => {
        if (authenticated) {
            const response = await fetch("/api/tipoventas/getAll");
            if (response.ok) {
                setRequestSolved((prev) => prev + 1);
                dispatch(tipoventasActions.update(await response.json()));
            } else {
                throw Error(await response.text());
            }
        }
    }, [authenticated]);

    useEffectAsync(async () => {
        if (authenticated) {
            const response = await fetch("/api/actividadeconomica");
            if (response.ok) {
                setRequestSolved((prev) => prev + 1);
                dispatch(actividadEconomicaActions.update(await response.json()));
            } else {
                throw Error(await response.text());
            }
        }
    }, [authenticated]);

    useEffectAsync(async () => {
        if (authenticated) {
            const response = await fetch("/api/municipio");
            if (response.ok) {
                setRequestSolved((prev) => prev + 1);
                dispatch(municipioActions.update(await response.json()));
            } else {
                throw Error(await response.text());
            }
        }
    }, [authenticated]);

    useEffectAsync(async () => {
        if (authenticated) {
            const response = await fetch("/api/departamento");
            if (response.ok) {
                setRequestSolved((prev) => prev + 1);
                dispatch(departamentoActions.update(await response.json()));
            } else {
                throw Error(await response.text());
            }
        }
    }, [authenticated]);

    useEffectAsync(async () => {
        if (authenticated) {
            const response = await fetch("/api/talonario/getAll");
            if (response.ok) {
                setRequestSolved((prev) => prev + 1);
                dispatch(talonarioActions.refresh(await response.json()));
            } else {
                throw Error(await response.text());
            }
        }
    }, [authenticated]);

    useEffectAsync(async () => {
        if (authenticated) {
            const response = await fetch("/api/tipocomprobantes/getAll");
            if (response.ok) {
                setRequestSolved((prev) => prev + 1);
                dispatch(tipocomprobantesActions.update(await response.json()));
            } else {
                throw Error(await response.text());
            }
        }
    }, [authenticated]);

    useEffectAsync(async () => {
        if (authenticated) {
            const response = await fetch("/api/comprobante?all=true");
            if (response.ok) {
                setRequestSolved((prev) => prev + 1);
                dispatch(comprobanteActions.refresh(await response.json()));
            } else {
                throw Error(await response.text());
            }
        }
    }, [authenticated]);

    useEffectAsync(async () => {
        if (authenticated) {
            const response = await fetch("/api/pago?all=true");
            if (response.ok) {
                setRequestSolved((prev) => prev + 1);
                dispatch(pagoActions.refresh(await response.json()));
            } else {
                throw Error(await response.text());
            }
        }
    }, [authenticated]);

    return (
        <div className={"pace " + (requestSolved == requestCount ? "pace-inactive" : "pace-active")}>
            <div
                className="pace-progress"
                style={{ transform: `translate3d(${(requestSolved / requestCount) * 100}%, 0px, 0px)` }}>
                <div className="pace-progress-inner"></div>
            </div>
            <div className="pace-activity"></div>
        </div>
    );
};

export default connect()(CachingController);
